/* eslint-disable max-len */
/* eslint-disable max-lines */
export const WELCOME_TO_DARPAN = 'Welcome to Darpan!';
export const DARPAN_TOOL_TAGLINE
  = 'A Tool for Employment Life Cycle Management';
export const GOOGLE_LOGIN = 'Login with google';
export const CANCEL_TEXT = 'Cancel';
export const CLOSE_TEXT = 'Close';
export const DECLINE_TEXT = 'No';
export const AUTHENTICATION_FAILED = 'Authentication failed';
export const SAVE_SUCCESS = 'Data saved successfully';
export const UPDATE_SUCCESS = 'Data updated successfully';
export const ENABLE_DISABLE_ROLE_DIALOG = {
  OOPS_TRY_AGAIN: 'Oops! Please try again',
  CANNOT_DISABLE: 'You cannot disable a role that is mapped to users',
  ENABLE: {
    TITLE_TEXT: 'Enable role',
    MESSAGE_TEXT: 'Are you sure you want to enable this role?',
    BUTTON_TEXT: 'Enable',
    BUTTON_ID: 'enable-role',
    RESPONSE_SUCCESS: 'Role has been enabled',
  },
  DISABLE: {
    TITLE_TEXT: 'Disable role',
    MESSAGE_TEXT: 'Are you sure you want to disable this role?',
    BUTTON_TEXT: 'Disable',
    BUTTON_ID: 'disable-role',
    RESPONSE_SUCCESS: 'Role has been disabled',
  },
};

export const ENABLE_DISABLE_CLIENT_DIALOG = {
  OOPS_TRY_AGAIN: 'Oops! Please try again',
  CANNOT_DISABLE: 'You cannot disable a client that has active projects',
  ENABLE: {
    TITLE_TEXT: 'Enable client',
    MESSAGE_TEXT: 'Are you sure you want to enable this client?',
    BUTTON_TEXT: 'Enable',
    BUTTON_ID: 'enable-client',
    RESPONSE_SUCCESS: 'Client has been enabled',
  },
  DISABLE: {
    TITLE_TEXT: 'Disable client',
    MESSAGE_TEXT: 'Are you sure you want to disable this client?',
    BUTTON_TEXT: 'Disable',
    BUTTON_ID: 'disable-client',
    RESPONSE_SUCCESS: 'Client has been disabled',
  },
};

export const ENABLE_DISABLE_ZOHO_CUSTOMER_DIALOG = {
  OOPS_TRY_AGAIN: 'Oops! Please try again',
  ENABLE: {
    TITLE_TEXT: 'Enable Zoho Client',
    MESSAGE_TEXT: 'Are you sure you want to enable this Zoho client?',
    BUTTON_TEXT: 'Enable',
    BUTTON_ID: 'enable-zoho-customer',
    RESPONSE_SUCCESS: 'Zoho client has been enabled',
  },
  DISABLE: {
    TITLE_TEXT: 'Disable Zoho Client',
    MESSAGE_TEXT: 'Are you sure you want to disable this Zoho client?',
    BUTTON_TEXT: 'Disable',
    BUTTON_ID: 'disable-zoho-customer',
    RESPONSE_SUCCESS: 'Zoho client has been disabled',
  },
};

export const LEAVE_UPLOAD = {
  UPDATED_START_DATE: 'updatedStartDate',
  UPLOADED_START_TIME: 'Upload Start Time',
  UPDATED_END_DATE: 'updatedEndDate',
  UPLOADED_END_TIME: 'Upload End Time',
  START_DATE: 'startDate',
  LEAVE_START_DATE: 'Leave Start Date',
  END_DATE: 'endDate',
  LEAVE_END_DATE: 'Leave End Date',
  RUN_BY: 'runBy',
  LEAVE_RUN_BY: 'Run By',
  STATUS: 'status',
  LEAVE_STATUS: 'Status',
  DATA_UPLOAD: 'Data Upload',
  LEAVE_UPLOAD_TITLE: 'Leave Upload',
  CUSTOM_DATE_PLACEHOLDER: 'Custom Leave Date Range',
  RUN_LEAVE_UPLOAD: 'Run Leave Upload',
  SYNC_LEAVE_UPLOAD: 'Sync',
  SYNC_LEAVE_LABEL: 'Sync leave',
  OOPS_TRY_AGAIN: 'Oops! Please try again',
  LEAVE_UPLOAD_ADD_SUCCESS: 'Manually triggered Successfully',
  UNABLE_TO_ADD_LEAVE_UPLOAD: 'Unable to upload leave! please try again',
  LEAVE_SYNC_UNSUCCESSFUL: 'Leave data Sync unsuccessful',
  LEAVE_SYNC_STARTED_SUCCESSFULLY: 'Leave data Sync started successfully',
  LEAVE_UPLOAD_SUCCESS: 'Leave data uploaded successfully',
  LEAVE_SYNC_IN_PROGRESS: 'Leave data Sync in progress',
  ADD_BUTTON_TEXT: 'Run Leave Upload',
  SELECT_START_DATE: 'Select Leave Start Date*',
  SELECT_END_DATE: 'Select Leave End Date*',
  PLACEHOLDER: 'Choose Date',
  RUN_BUTTON: 'Run Leave Upload',
  FILE_UPLOAD: 'File Upload',
  UPLOAD: 'Upload',
  START_DATE_LABEL: 'Start Date*',
  END_DATE_LABEL: 'End Date*',
  SCHEDULER_TYPE: 'type',
  TYPE: 'Type',
};
export const ENABLE_DISABLE_CATEGORY_DIALOG = {
  OOPS_TRY_AGAIN: 'Oops! Please try again',
  CANNOT_DISABLE: 'You cannot disable a category that is mapped to users',
  ENABLE: {
    TITLE_TEXT: 'Enable category',
    MESSAGE_TEXT: 'Are you sure you want to enable this category?',
    BUTTON_TEXT: 'Enable',
    BUTTON_ID: 'enable-category',
    RESPONSE_SUCCESS: 'Category has been enabled',
  },
  DISABLE: {
    TITLE_TEXT: 'Disable category',
    MESSAGE_TEXT: 'Are you sure you want to disable this category?',
    BUTTON_TEXT: 'Disable',
    BUTTON_ID: 'disable-category',
    RESPONSE_SUCCESS: 'Category has been disabled',
  },
};
export const ENABLE_DISABLE_CERTIFI_DIALOG = {
  ENABLE: {
    TITLE_TEXT: 'Enable certification',
    MESSAGE_TEXT: 'Are you sure you want to enable this certification?',
    BUTTON_TEXT: 'Enable',
    BUTTON_ID: 'enable-certification',
    RESPONSE_SUCCESS: 'Certification has been enabled',
  },
  DISABLE: {
    TITLE_TEXT: 'Disable certification',
    MESSAGE_TEXT: 'Are you sure you want to disable this certification?',
    BUTTON_TEXT: 'Disable',
    BUTTON_ID: 'disable-certification',
    RESPONSE_SUCCESS: 'Certification has been disabled',
  },
};
export const ENABLE_DISABLE_SKILL_DIALOG = {
  ENABLE: {
    TITLE_TEXT: 'Enable skill',
    MESSAGE_TEXT: 'Are you sure you want to enable this skill?',
    BUTTON_TEXT: 'Enable',
    BUTTON_ID: 'enable-skill',
    RESPONSE_SUCCESS: 'Skill has been enabled',
  },
  DISABLE: {
    TITLE_TEXT: 'Disable skill',
    MESSAGE_TEXT: 'Are you sure you want to disable this skill?',
    BUTTON_TEXT: 'Disable',
    BUTTON_ID: 'disable-skill',
    RESPONSE_SUCCESS: 'Skill has been disabled',
  },
};

export const ADD_EDIT_DIALOG = {
  ADD_MAP: 'Map',
  ADD_ROLE: 'Add role',
  ADD_CLIENT: 'Add client',
  ROLE_NAME: 'Role name*',
  DESCRIPTION: 'Description',
  ROLE_NAME_PLACEHOLDER: 'Enter role name',
  DESCRIPTION_PLACEHOLDER: 'Enter the description',
  EDIT_ROLE: 'Edit role',
  TITLE_TEXT: 'Disable role',
  MESSAGE_TEXT: 'Are you sure you want to disable this role?',
  BUTTON_TEXT: 'Disable',
  BUTTON_ID: 'disable-role',
  ADD_CERTIFICATION: 'Add certification',
  PROVIDER_ID: 'Provider Certification ID',
  CERTIFICATION_NAME: 'Certification name*',
  CERTIFICATION_PROVIDER: 'Certification provider*',
  VALIDITY: 'Validity in years',
  EDIT_CERTIFICATION: 'Edit certification',
  CERTIFICATION_NAME_PLACEHOLDER: 'Enter certification name',
  PROVIDER_ID_PLACEHOLDER: 'Provider ID',
  CERTIFICATION_PROVIDER_NAME: 'Enter certification provider name',
  VALIDITY_YEARS: 'Enter Validity in years',
  CATEGORY: 'Category*',
  SUB_CATEGORY: 'Sub category*',
  EDIT_TARGET: 'Edit target',
  SET_TARGET: 'Set target',
  EMPLOYEE_NAME_PLACEHOLDER: 'Enter employee name',
  SELECT_CERTIFICATION: 'Select certification',
  CERTIFICATION_ACHIEVED_DATE: 'Choose date',
  EDIT_PERFORMANCE_PERIOD: 'Edit performance period',
  ADD_PERFORMANCE_PERIOD: 'Add performance period',
  PERFORMANCE_YEAR_NAME: 'Performance year*',
  PERFORMANCE_YEAR_PLACEHOLDER: 'Enter performance year name',
  PERFORMANCE_START_DATE: 'Start date*',
  PERFORMANCE_END_DATE: 'End date*',
  PERFORMANCE_START_PLACEHOLDER: 'Select start date',
  PERFORMANCE_END_PLACEHOLDER: 'Select end date',
  ADD_CLIENT_TITLE: 'Add Client',
  EDIT_CLIENT_TITLE: 'Edit Client',
};

export const SUBMIT = 'Submit';
export const UPDATE = 'Update';
export const SAVE = 'Save';
export const DOWNLOAD = 'Download';
export const YES = 'Yes';
export const NO = 'No';
export const CHOOSE_DATE = 'Choose Date';
export const OOPS_TRY_AGAIN = 'Oops! Please try again';
export const NO_RECORDS_FOUND = 'No records found';
export const CONFIRMATION = 'Confirmation';
export const NOTE = 'Note:';
export const CONTINUE = 'Continue';
export const FETCH = 'Fetch';

export const ADD_EDIT_RESPONSE_MESSAGES = {
  ROLE_ADDED_SUCCESS: 'Role added successfully',
  ENTER_ROLE_NAME: 'Please enter a role name.',
  ROLE_NAME_TAKEN: 'This role name has already been taken',
  DESCRIPTION_PLACEHOLDER: 'Enter the description',
  OOPS_TRY_AGAIN: 'Oops! Please try again',
  UNABLE_TO_ADD_ROLE: 'Unable to add the role! please try again',
  ROLE_NAME_MUST_BE: 'Role name must be 3 to 100 characters long',
  ROLE_NAME_INVALID: 'Role name is invalid',
  ROLE_UPDATED_SUCCESS: 'Role Updated Successfully',
  OOPS_UPDATE_TRY_AGAIN: 'Oops! Unable to update the role. Please try again.',
  UNABLE_TO_UPDATE_ROLE: 'Unable to update the role',
  CERTIFICATION_NAME_MUST_BE: 'Certification name must be 3 to 50 characters',
  CERTIFICATION_NAME_INVALID: 'Certification name is Invalid',
  CERTIFICATION_ADDED_SUCCESS: 'Certification added successfully',
  CERTIFICATION_UPDATED_SUCCESS: 'Certification updated successfully',
  UNABLE_TO_ADD_CERTIFICATION:
    'Unable to add the certification! please try again',
  CERTIFICATION_REQUIRED: 'lease add the required field',
  CERTIFICATION_CONFLICT: 'Certification already exists',
  PROVIDER_ID_MUST_BE: 'Provider ID must be within 20 characters',
  PROVIDER_ID_INVALID: 'Provider ID is invalid',
  CERTIFICATION_PROVIDER_MUST_BE:
    'Certification provider must be 3 to 50 characters',
  CERTIFICATION_PROVIDER_INVALID: 'Certification provider is Invalid',
  VALIDITY_MUST_BE: 'Validity must be must be within 3 characters',
  VALIDITY_INVALID: 'Please enter numbers only',
  DELETE_SUCCESS: 'Mapping is deleted',
  EMPLOYEE_NAME_MUST_BE: 'Employee name must be 1 to 50 characters',
  EMPLOYEE_NAME_INVALID: 'Employee name is invalid',
  CERTIFICATION_MAP_ADDED: 'Certification map added successfully',
  PERFORMANCE_CYCLE_NAME_MUST_BE: 'Performance cycle name must be 3 characters',
  PERFORMANCE_PERIOD_ADD_SUCCESS: 'Performance period added successfully',
  // eslint-disable-next-line id-length
  PERFORMANCE_PERIOD_UPDATE_SUCCESS: 'Performance period update successfully',
  PERFORMANCE_CYCLE_EXISTS: 'Performance cycle already exists',
  UNABLE_TO_ADD_PERFORM_CYCLE:
    'Unable to add the Performance cycle! please try again',
  UNABLE_TO_UPDATE_PERFORM_CYCLE:
    'Unable to update the Performance cycle! please try again',
  ENTER_PERFORMANCE_YEAR_NAME: 'Please enter performance year name.',
  ENTER_START_DATE: 'Please enter start date.',
  ENTER_END_DATE: 'Please enter end date.',
  START_DATE_BEFORE_END_DATE: 'Start date must be before end date.',
  START_DATE_LESS_THAN_END_DATE: 'Start date must be less than end date.',
  PERFORM_CYCLE_NO_SPECIAL_CHAR: 'No special characters allowed.',
  SELECT_VALID_DATE_RANGE: 'Please select a valid date range.',
  CLIENT_ADDED_SUCCESS: 'Client added successfully',
  CLIENT_UPDATED_SUCCESS: 'Client updated successfully',
  ENTER_CLIENT_NAME: 'Please enter a client name.',
  ENTER_CLIENT_STATUS: 'Please enter client status.',
  CLIENT_NAME_MIN_LENGTH: 'Client name must be at least 2 characters',
  CLIENT_ALREADY_EXISTS: 'This client name has already been taken',
  CLIENT_NOT_FOUND: 'Client not found',
  INTERNAL_SERVER_ERROR: 'Internal server error',
  SOMETHING_WENT_WRONG: 'Something went wrong',
};

export const ADD_EDIT_SKILLS = {
  ADD_SKILL: 'Add skill',
  SKILL_NAME: 'Skill name*',
  DEPARTMENT: 'Department*',
  VERTICAL: 'Vertical*',
  ENTER_SKILL_NAME: 'Enter skill name',
  EDIT_SKILL: 'Edit skill',
};

export const SELECT = 'Select';
export const SEARCH = 'Search...';
export const CERTIFICATION_MASTER = 'Certification master';
export const CERTIFICATION_FIELD = {
  CERTIFICATION_ID: 'certificationCode',
  CERTIFICATION_NAME: 'certificationName',
  PROVIDER_ID: 'providerId',
  PROVIDER_NAME: 'providerName',
  VALIDITY: 'validity',
  IS_ACTIVE: 'isActive',
  CATEGORY_NAME: 'categoryName',
  SUB_CATEGORY_NAME: 'subCategoryName',
};

export const CERTIFICATION_HEADERNAME = {
  CERTIFICATION_ID: 'Certification ID',
  CERTIFICATION_NAME: 'Certification Name',
  PROVIDER_ID: 'Provider Certification ID',
  PROVIDER_NAME: 'Provider',
  VALIDITY: 'Validity in years',
  ENABLE_DISABLE: 'Enable/Disable',
  ACTION: 'Action',
  ADD_CERTIFICATION: 'Add Certification',
  CATEGORY: 'Category',
  SUB_CATEGORY: 'Sub category',
};

export const MAP_EDIT_CERTIFICATION_DIALOG = {
  MAP: {
    TITLE_TEXT: 'Map certification',
    SUCCESS_MESSAGE: 'Certification mapped',
  },
  EDIT: {
    TITLE_TEXT: 'Edit mapping',
    SUCCESS_MESSAGE: 'Mapping updated',
  },
  NOTE_MESSAGE: 'On click save, the employee will receive the email feedback',
  SUBMIT_FAILURE_MESSAGE:
    'Couldn’t save information due to technical error! Please try again.',
};

export const ROLE_MASTER = 'Role Master';
export const ROLE_MASTER_FIELD = {
  ROLE_ID: 'roleId',
  ROLE_NAME: 'roleName',
  DESCRIPTION: 'description',
  IS_ACTIVE: 'isActive',
  ROLE_CODE: 'roleCode',
};
export const ROLE_MASTER_HEADERNAME = {
  ID: 'ID',
  ROLE_NAME: 'Role Name',
  DESCRIPTION: 'Description',
  ENABLE_DISABLE: 'Enable/Disable',
  ACTION: 'Action',
};

export const CLIENT_DETAILS_MASTER = 'Client Details';
export const CLIENT_DETAILS_FIELD = {
  CLIENT_ID: 'clientId',
  CLIENT_NAME: 'clientName',
  CLIENT_STATUS: 'clientStatus',
  TOTAL_PROJECTS_LINKED: 'totalProjectsLinked',
  IS_ACTIVE: 'isActive',
};
export const CLIENT_DETAILS_HEADERNAME = {
  SL_NO: 'Sl.No',
  CLIENT_ID: 'Client Id',
  CLIENT_NAME: 'Client Name',
  CLIENT_STATUS: 'Client Status',
  TOTAL_PROJECTS_LINKED: 'Total Projects Linked',
  ENABLE_DISABLE: 'Enable/Disable',
  ACTION: 'Action',
};

export const MASTER_ROLE = 'Deal workflow role master';
export const MASTER_ROLE_FIELD = {
  ROLE_ID: 'roleId',
  ROLE_NAME: 'roleName',
  DESCRIPTION: 'description',
  IS_ACTIVE: 'isActive',
};
export const MASTER_ROLE_HEADERNAME = {
  ID: 'ID',
  ROLE_NAME: 'Role',
  DESCRIPTION: 'Remarks',
  ENABLE_DISABLE: 'Enable/Disable',
};

export const SKILL_MASTER = 'Skill master';

export const BLOGS = {
  BLOGS: 'Blogs',
};

export const BLOGS_TABLE_HEADER = {
  CREATED_DATE: 'Created date',
  NAME: 'Name',
  ASSET_TYPE: 'Asset type',
  STATUS: 'Status',
  MONTH: 'Month',
  WEEK: 'Week',
  PUBLISH_DATE: 'Publish date',
  AUTHOR: 'Author',
  EMP_EMAIL: 'Author Email',
  EMP_ID: 'Author ID',
};

export const BLOGS_TABLE_FIELD = {
  CREATED_DATE: 'createdDate',
  NAME: 'name',
  MONTH: 'month',
  ASSET_TYPE: 'type',
  STATUS: 'status',
  WEEK: 'week',
  PUBLISH_DATE: 'publishedDate',
  AUTHOR: 'author',
  EMP_EMAIL: 'emailId',
  EMP_ID: 'employeeId',
};

export const SKILL_MASTER_TABLE_HEADER = {
  ID: 'ID',
  SKILL_ID: 'Skill ID',
  SKILL_NAME: 'Skill name',
  DEPARTMENT: 'Department',
  VERTICAL: 'Vertical',
  ENABLE_DISABLE: 'Enable/Disable',
  ACTION: 'Action',
};

export const SKILL_MASTER_TABLE_FIELD = {
  SKILL_ID: 'skillId',
  SKILL_CODE: 'skillCode',
  SKILL_NAME: 'skillName',
  DEPARTMENT: 'department',
  VERTICAL: 'verticals',
  IS_ACTIVE: 'isActive',
  ACTION: 'action',
};

export const ADD_EDIT_SKILL_RESPONSE_MSG = {
  OOPS_TRY_AGAIN: 'Oops! Please try again',
  SKILL_NAME_MUST_BE: 'Skill name must be 3 to 20 characters long',
  FILL_REQUIRED_FIELD: 'Please fill the required field',
  SKILL_ADDED_SUCCESS: 'Skill added successfully',
  SKILL_NAME_INVALID: 'Skill name is invalid',
  SKILL_UPDATED_SUCCESS: 'Skill updated successfully',
  DATA_ALREADY_EXISTS: 'Data already exists',
  SKILL_ALREADY_EXISTS: 'This skill already exists, please select another.',
};

export const DELETE_USER_SKILL_DIALOG = {
  TITLE_TEXT: 'Delete skill',
  MESSAGE_TEXT: 'Are you sure you want to delete this skill from the user?',
  BUTTON_TEXT: 'Delete',
  BUTTON_ID: 'delete-skill',
  RESPONSE_SUCCESS: 'Skill is deleted',
  OOPS_TRY_AGAIN: 'Oops! Please try again',
};
export const SET_TARGET = {
  SET_TARGET_TITLE: 'Set targets',
  SET_TARGET: 'Set target',
  TOTAL_TARGET: 'Total target',
  TARGETS: 'Targets',
  ENTER_VALID_NUMBER: 'Please enter a valid number',
  REQUIRED_FILED: 'Please fill the required field',
  TARGET_SET: 'Targets are set',
  OOPS_TRY_AGAIN: 'Oops! Please try again.',
  CERTIFICATION_NO_DATA:
    'Certification not available. Please add it under Master and set the target.',
};
export const CERTIFICATION_MAP = 'Map Certifications';
export const CERTIFICATION_MAP_HEADER = {
  ID: 'ID',
  NAME: 'Name',
  EMAIL: 'Email',
  VERTICAL: 'Vertical',
  CERTIFICATION_ID: 'Certification ID',
  CERTIFICATION_NAME: 'Certification name',
  ACHIEVED_DATE: 'Achieved date',
  Expiry_DATE: 'Expiry date',
  Employee_status: 'Employee status',
  ACTION: 'Actions',
};
export const CERTIFICATION_MAP_FIELD = {
  USER_ID: 'userId',
  ID: 'id',
  NAME: 'userName',
  USER_CODE: 'userCode',
  EMAIL: 'userEmail',
  VERTICAL: 'vertical',
  CERTIFICATION_ID: 'certificationId',
  CERTIFICATION_NAME: 'certifications',
  ACHIEVED_DATE: 'achievedDate',
  EXPIRY_DATE: 'expiredDate',
  EMPLOYEE_STATUS: 'employeeStatus',
};
export const DELETE_DIALOG = {
  TITLE_TEXT: 'Delete mapping',
  MESSAGE_TEXT: 'Are you sure you want to delete this mapping from the user?',
  BUTTON_TEXT: 'Delete',
  BUTTON_ID: 'Delete-mapping',
  RESPONSE_SUCCESS: 'Mapping is deleted',
  DELETE_TEXT: 'Are you sure you want to delete this feedback?',
  TITLE_TEXT1: 'Delete feedback',
};
export const LOGOUT_DIALOG = {
  LOGOUT_MESSAGE: 'Are you sure you want to logout?',
  TITLES_TEXT: 'Logout',
  LOGOUT_TEXT: 'Yes',
};
export const EDIT_TARGET = {
  EDIT_TARGET_TITLE: 'Edit targets',
  TARGET_QUARTER: 'Quarter',
  SELECT_CERTIFICATION: 'Select Certification',
  EXIT_CONFIRM: 'You sure you want to exit?',
  CONFIRM_SAVE_DATA: 'Do you want to save the data?',
  TARGET_UPDATED: 'Targets are updated',
  CONFIRMATION: 'Confirmation',
  CONFIRM_SAVE_TARGET:
    'Are you sure you want to save the certification targets?',
};
export const TARGET_DASHBOARD = {
  TARGET_CERTIFICATIONS: 'Certifications',
  TARGET_SET: 'Targets set',
  PENDING: 'Pending',
  ACHIEVED: 'Achieved',
  SERVER_DOWN: 'Server down',
  OOPS_TRY_AGAIN: 'Oops! Please try again',
  NO_TARGETS: 'No target has been set for the current year',
  TOOLTIP_TEXT:
    'Target has already been set for next 3 years.If any changes, please try editing',
};
export const MAP_EDIT_USER_ROLE = {
  MAP_ROLE: 'Map role',
  SELECT_ROLE: 'Select role*',
  EDIT_ROLE: 'Edit role',
};
export const MAP_EDIT_USER_RESPONSE_MSG = {
  OOPS_TRY_AGAIN: 'Oops! Please try again',
  TECHNICAL_ERROR:
    "Couldn't save information due to technical error! Please try again.",
  FILL_REQUIRED_FIELD: 'Please fill the required field',
  MAP_ADDED_SUCCESS: 'Users are mapped to role',
  ROLE_UPDATED_SUCCESS: 'Roles are updated',
};
export const CERTIFICATION_OVERVIEW = 'Certifications overview';

export const SKILL_MAP_DASHBOARD = {
  NO_DATA_TEXT: 'Search to see the results',
  CORE_SKILL: 'Core Skill',
  SEARCH_PLACEHOLDER: {
    EMPLOYEE: 'Search employee',
    DEPARTMENT: 'Search department',
    VERTICAL: 'Search vertical',
    SKILL: 'Search skill',
  },
  SEARCH_FILTER_TEXT: {
    EMPLOYEE: 'Filter by employee',
    DEPARTMENT: 'Filter by department',
    VERTICAL: 'Filter by vertical',
    SKILL: 'Filter by skill',
  },
  ADD: {
    BUTTON_TEXT: 'Map',
  },
  EDIT: {
    BUTTON_TEXT: 'Edit',
    CANCEL_BUTTON_ID: 'cancel-update-skill-map',
    UPDATE_BUTTON_ID: 'update-skill-map',
    SELECT_LEVELS: 'Select levels',
    IS_CORE_SKILL_LABEL: 'Check if this is a core skill of the employee',
    SUCCESS_MESSAGE: 'Skill mapping updated',
  },
  DELETE: {
    BUTTON_TEXT: 'Delete',
  },
  VIEW_PROFILE: {
    BUTTON_TEXT: 'View profile',
  },
  MAP_SKILL: {
    TITLE_TEXT: 'Map skill',
    NO_DATA_TEXT: 'Fill in the fields above to see the results',
    NO_USERNAME_MATCH: 'No matches found',
    SEARCH_CONTAINER: {
      EMPLOYEE_NAME: {
        LABEL: 'Employee name*',
        PLACEHOLDER: 'Enter employee name',
      },
      EMPLOYEE_ID: {
        LABEL: 'Employee ID*',
      },
      VERTICAL: {
        LABEL: 'Vertical*',
        PLACEHOLDER: 'Select',
      },
      DEPARTMENT: {
        LABEL: 'Department*',
        PLACEHOLDER: 'Select',
      },
    },
    SUCCESS_MESSAGE: 'Skill mapping successful',
    DUPLICATE_MAP_MESSAGE: 'Duplicate skill mapping',
    EXIT_CONFIRM: 'Are you sure you want to exit?',
    DUPLICATE_MAP_ERROR:
      'is mapped already to the user. Please uncheck to proceed further.',
  },

  DELETE_SKILL_MAP: 'Delete mapping',
  DELETE_SKILL_MAP_MESSAGE:
    'Are you sure you want to delete this skill from the user?',
  DELETE_SKILL_MAP_ID: 'Delete mapping',
  DELETE_SKILL_MAP_BUTTON: 'Delete',
};

export const USER_MANAGEMENT_FIELD = {
  USER_ID: 'USER_ID',
  ID: 'id',
  NAME: 'fullName',
  EMAIL: 'emailId',
  VERTICAL: 'vertical',
  CERTIFICATION_ID: 'certificationId',
  WORK_LOCATION: 'location',
  DEPARTMENT: 'department',
  DESIGNATION: 'designation',
  ROLE: 'roleName',
};
export const USER_MANAGEMENT_HEADER = {
  ID: 'ID',
  NAME: 'Name',
  EMAIL: 'Email',
  VERTICAL: 'Vertical',
  CERTIFICATION_ID: 'Certification ID',
  WORK_LOCATION: 'Work location',
  DEPARTMENT: 'Department',
  DESIGNATION: 'Designation',
  ROLE: 'Role',
  ACTION: 'Actions',
};
export const USER_MANAGEMENT = {
  TOOLTIP: 'Select users to map role',
  EDIT: 'Edit',
  VIEW_PROFILE: 'View profile',
  SEARCH: 'Search...',
  MAP_ROLE: 'Map role',
  DOWNLOAD_REPORT: 'Please select a report type to download.',
  DOWNLOAD_SUCCESS: 'Report downloaded successfully.',
  DOWNLOAD_FAILURE: 'Oops, something went wrong while downloading.',
};

export const SKILL_CERT_PROFILE = {
  CERTIFICATIONS: 'Certifications',
  FILL_TRANSITION: 'Fill transition',
  TOTAL: 'Total',
  PROFESSIONAL: 'Professional',
  ACHIEVED_DATE: 'Achieved date',
  EXPIRY_DATE: 'Expiry date',
  SKILLS: 'Skills',
  TOTAL_SKILL_COUNT: 'Total skills count',
  CORE: 'Core',
  NON_CORE: 'Non Core',
  AWARDS: 'Awards',
  TOTAL_AWARD_COUNT: 'Total awards count',
  VIEW: 'View',
  DRI: 'DRI scores',
  TOTAL_DRI_SCORE: 'Total DRI scores',
  DELETE_AWARD: 'Delete award',
  DELETE_AWARD_MSG: 'Are you sure you want to delete this award from the user?',
  DELETE: 'Delete',
  NO_DATA: 'No data to display',
  AWARD_TITLE: 'Add Awards',
  AWARD_NAME: 'Award name*',
  AWARD_NAME_PLACEHOLDER: 'Enter name of the award',
  AWARD_YEAR_PLACEHOLDER: 'Select year',
  AWARD_DESCRIPTION: 'Description*',
  AWARD_DESC_PLACEHOLDER: 'Enter the description...',
  SUCCESS_MSG: 'Award is deleted',
  TRY_AGAIN: 'Couldn’t delete due to technical error! Please try again.',
  OOPS_TRY_AGAIN: 'Oops! Please try again.',
  ADD_SUCCESS_MSG: 'Award is added',
  ADD_TRY_AGAIN:
    'Couldn’t save information due to technical error! Please try again.',
  NO_PREVIOUS_PROJECTS: 'No previous project details available',
};

export const MANAGE_KPI_DASHBOARD = {
  MANAGE_KPI: 'Manage KPI',
  OOPS_TRY_AGAIN: 'Oops! Please try again.',
  SELECT_PLACEHOLDER: {
    VERTICAL: 'Select vertical',
    DEPARTMENT: 'Select department',
    DESIGNATION: 'Select designation',
    PERFORMANCE: 'Select performance period',
  },
  SEARCH: 'Search',
  SET_TARGET: 'Set target',
  EDIT_TARGET: 'Edit target',
  ERROR_MESSAGE: 'Select the filters above to see the results',
  SET: {
    TITLE: 'Set KPI targets',
    SELECT_PLACEHOLDER: {
      KPI: 'KPI',
      TARGET_FORMAT: 'Select',
      TARGET_IS: 'Select',
      YES_NO: 'Select',
    },
    LABEL: {
      TARGET_FORMAT: 'Target format',
      TARGET_IS: 'Target is',
    },
    FAILURE_REQUIRED_TARGET_VALUES: 'Please fill all KPI details to proceed.',
  },
  EDIT: {
    TITLE: 'Edit KPI targets',
    SELECT_PLACEHOLDER: {
      KPI: 'KPI',
      TARGET_FORMAT: 'Select',
      TARGET_IS: 'Select',
      YES_NO: 'Select',
    },
    LABEL: {
      TARGET_FORMAT: 'Target format',
      TARGET_IS: 'Target is',
    },
  },
  SELECT_FROM: {
    PERFORMANCE_PERIOD: 'Select performance period*',
    PREVIOUS_PERFORMANCE: 'Select from previous performance period*',
    CHECKBOX_PREVIOUS: 'Select to copy KPI from previous performance period',
  },
  REQUIRED_FILED: 'Please fill the required field',
  SELECT_VERTICAL_DEPT_DESG:
    'Please select vertical, department and designation to view the KPI.',
  SELECT_FILTERS_MSG: 'Select the filters above to see the results.',
};

export const EMPLOYEE_PERFORMANCE = {
  PERFORMANCE: 'Performance',
  ERROR_MESSAGE: 'No KPI’s available',
  KPI: 'KPI',
  INDICATORS: 'Indicators',
  SUGGESTED: 'Suggested',
  TARGET: 'Target',
  ACHIEVED: 'Achieved',
  NO_PERFORMANCE_DATA: 'No data available.',
  REMARKS: 'Remarks',
};

export const DEAL_TRANSITION_MASTER = 'Deal transition - Deal status master';

export const DEAL_STATUS_HEADER = {
  STATUS: 'Status',
  REMARKS: 'Remarks',
  UPDATED_BY: 'Updated by',
  ENABLE_DISABLE: 'Enable/Disable',
  ACTIVE: 'Active',
};

export const DEAL_STATUS_FIELD = {
  STATUS: 'status',
  REMARKS: 'remarks',
  UPDATED_BY: 'updatedBy',
  ENABLE_DISABLE: 'Enable/Disable',
  ACTIVE: 'active',
};

export const DEAL_PARAMTER_MASTER = 'Deal parameter master';

export const DEAL_PARAMTER_HEADER = {
  PARAMETER: 'Parameter',
  DATA_TYPE: 'Data type',
  REMARKS: 'Remarks',
  USE_FOR_SLA: 'Use for sla',
  USE_FOR_WORKFLOW: 'Use for workflow',
};

export const DEAL_PARAMTER_FIELD = {
  NAME: 'parameter_name',
  DATA_TYPE: 'data_type',
  REMARKS: 'remarks',
  IS_SLA_ENABLED: 'sla',
  IS_WORKFLOW_ENABLED: 'workflow',
};

export const PROJECTS_PROFILE = {
  PROJECTS: 'Projects',
  HOURS_LOGGED: 'Total hours logged:',
  ALLOCATED: 'Allocated:',
  SKILLS_USED: 'Skills used',
  ALLOCATION: 'Allocation',
  TOTAL: 'Total:',
  ONGOING: 'Ongoing:',
  RECOGNITIONS: 'Recognitions',
  OOPS_TRY_AGAIN: 'Oops! Please try again',
  FEEDBACK_DELETED: 'Feedback is deleted',
  TECHNICAL_ERROR: 'Couldn’t delete due to technical error! Please try again.',
  FEEDBACK_REQUIRED: 'Feedback is required!',
  CLIENT_DATE_REQUIRED: 'Date is required!',
  CLIENT_NAME_REQUIRED: 'Client name is required!',
  RECOGNITION_ADDED: 'Recognition is added',
  ADD_RECOGNITION: 'Add recognition',
  STAR_OF_THE_MONTH: 'Star of the month',
  CLIENT_APPRECIATION: 'Client appreciations',
  FEEDBACK: 'Feedback*',
  FEEDBACK_PLACEHOLDER: 'Enter the feedback...',
  CHOOSE_DATE: 'Choose date*',
  DATE_PLACEHOLDER: 'Choose date',
  CLIENT_NAME: 'Client name*',
  CLIENT_PLACEHOLDER: 'Enter client name',
  SELECT_YEAR: 'Select year',
  SELECT_MONTH: 'Select month',
  INFORMATION_NONE: 'Information not available',
  NOTE_MESSAGE: 'On click save, the employee will receive the email feedback',
  START_DATE: 'Start date:',
  END_DATE: 'End date:',
};

export const DEAL_TRANSITION_DASHBOARD = 'Deal transition - Dashboard';
export const DEAL_TRANSITION_DETAILS_VIEW = {
  DEAL_SUMMARY: 'Deal summary',
  DEAL_EFFORTS: 'Deal efforts',
  DEAL_ESTIMATION_LINK: 'View detailed estimation',
  DEAL_FINANCIAL: 'Deal Financials',
  DEAL_EFFORTS_SUB: 'Effort:',
  DEAL_PRICING_TEMP_LINK: 'View pricing template',
  DEAL_PAYMENT_TERMS: 'Payment terms',
  DEAL_VALUE: 'Deal value:',
  DEAL_MARGIN: 'Margin:',
  DEAL_BILLING_RATE: 'Billing rate:',
  DEAL_TERMS_CONDITIONS: 'Terms and conditions',
  DEAL_ADDITIONAL_DETAILS: 'Deal additional details',
};

export const DECLARE_PERFORMANCE_PERIOD = {
  TITLE: 'Declare performance period',
  FILTERS: {
    YEAR: 'Select year',
    PERFORMANCE_TYPE: 'Select performance type',
  },
  ADD_BUTTON_TEXT: 'Add',
  MASTER_TABLE_FIELD: {
    ID: 'id',
    YEAR: 'year',
    CYCLE_NAME: 'cycleName',
    CREATED_AT: 'createdAt',
    START_DATE: 'startDate',
    LAST_UPDATED_AT: 'lastUpdatedDate',
    END_DATE: 'endDate',
    ACTION: 'action',
  },
  MASTER_TABLE_HEADER: {
    PERFORMANCE_PERIOD: 'Performance period',
    START_DATE: 'Start date',
    END_DATE: 'End date',
    LAST_UPDATED: 'Last updated',
    ACTION: 'Actions',
  },
  NO_RECORDS: 'No Performance period available',
  NO_PREVIOUS_RECORDS: 'No previous performance period available',
};

export const CERTIFICATION_CATEGORY = {
  TITLE: 'Certification category',
  FILTERS: {
    YEAR: 'Select year',
    PERFORMANCE_TYPE: 'Select performance type',
  },
  ADD_BUTTON_TEXT: 'Add Category',
  CATEGORY_TABLE_HEADER: {
    CATEGORY: 'Category',
    SUBCATEGORY: 'Sub category',
    ENABLE_DISABLE: 'Enable/Disable',
    ACTION: 'Action',
  },
  CATEGORY_TABLE_FIELD: {
    CATEGORY_NAME: 'categoryName',
    SUB_CATEGORY_NAME: 'subCategoryName',
    IS_ACTIVE: 'isActive',
    ACTION: 'Actions',
  },
  PLACE_HOLDER: {
    CATEGORY: 'Select category',
    SUB_CATEGORY: 'Select sub category',
  },
  NO_PREVIOUS_RECORDS: 'No previous performance period available',
  CATEGORY: 'Category*',
  ADD_SUB_CATEGORY: 'Add sub category*',
  ENTER_CATEGORY_NAME: 'Enter category name',
  ENTER_SUB_CATEGORY_NAME: 'Enter sub category name',
  EDIT_CATEGORY: 'Edit category',
  ENTER_CATEGORY: 'Enter category',
  ENTER_SUB_CATEGORY: 'Enter sub category',
  NAME_MUST_BE: 'Must be 3 to 32 characters long',
  REQUIRED_FILED: 'Please fill the required field',
  SUBCATEGORY_UNIQUE: 'Sub category must be unique',
};

export const DEAL_TRANSITION_FORM = {
  SALES_TO_CE: 'Sales to CE transition form',
  SHOW_SAVED_QUESTIONS: 'Show saved questions',
  UPLOAD_FILE: 'Upload file',
  QUESTION_REMOVED: 'Question is removed from saved list',
  QUESTION_SAVED_FOR_LATER: 'Question saved for later',
  SHOW_ALL_QUESTIONS: 'Show all questions ',
  DRAFT_SAVED: 'Draft saved',
  NO_RECORDS_TO_DISPLAY: 'No records to display',
};
export const ENABLE_DISABLE_DEALSTATUS_DLG = {
  OOPS_TRY_AGAIN: 'Oops! Please try again',
  CANNOT_DISABLE: 'You cannot disable a status',
};

export const CANNOT_DISABLE_DEAL_ROLE_DLG = {
  CANNOT_DISABLE: 'You cannot disable a role that is mapped to users',
};

export const MANAGE_KPI = {
  MANAGE_KPI: 'Manage KPI',
};

export const COST_MASTER = {
  COST_MASTER: 'Cost Master',
};

export const EMPLOYEE_COST = 'Employee Cost';

export const EMPLOYEE_COST_FIELD = {
  SR_NO: 'srNo',
  BUSINESS_VERTICAL: 'businessVertical',
  ROLE: 'role',
  EXPERIENCE: 'experience',
  LOCATION: 'location',
  PER_DAY_COST: 'perDayCost',
};

export const EMPLOYEE_COST_HEADER = {
  SR_NO: 'Sr.No.',
  BUSINESS_VERTICAL: 'Business Vertical',
  ROLE: 'Role',
  EXPERIENCE: 'Experience',
  LOCATION: 'Location',
  PER_DAY_COST: 'Per Day Price',
};

export const VENDOR_COST = 'Vendor Cost';

export const VENDOR_COST_FIELD = {
  SR_NO: 'srNo',
  Role: 'role',
  EXPERIENCE: 'experience',
  LOCATION: 'location',
  PER_DAY_PRICE: 'perDayCost',
};
export const VENDOR_COST_HEADER = {
  SR_NO: 'Sr.No',
  Role: 'Role',
  EXPERIENCE: 'Experience',
  LOCATION: 'Location',
  PER_DAY_PRICE: 'Per Day Price',
};

export const CLOUD_COST = 'Cloud Cost';

export const CLOUD_COST_FIELD = {
  SR_NO: 'srNo',
  ENVIRONMENT: 'environment',
  UNIT: 'unit',
  COST_AND_CURRENCY: 'cost',
  REMARKS: 'remark',
};

export const CLOUD_COST_HEADER = {
  SR_NO: 'Sr. No',
  ENVIRONMENT: 'Environment',
  UNIT: 'Unit',
  COST_AND_CURRENCY: 'Cost & Currency',
  REMARKS: 'Remarks',
};

export const DATE_RANGE_PICKER = {
  RESET: 'Reset',
  APPLY: 'Apply',
};

export const EFFORT_UPLOAD = {
  UPDATED_START_DATE: 'updatedStartDate',
  UPLOADED_START_TIME: 'Upload Start Time',
  UPDATED_END_DATE: 'updatedEndDate',
  UPLOADED_END_TIME: 'Upload End Time',
  START_DATE: 'startDate',
  EFFORT_START_DATE: 'Effort Start Date',
  END_DATE: 'endDate',
  EFFORT_END_DATE: 'Effort End Date',
  RUN_BY: 'runBy',
  EFFORT_RUN_BY: 'Run By',
  STATUS: 'status',
  EFFORT_STATUS: 'Status',
  DATA_UPLOAD: 'Data Upload',
  EFFORT_UPLOAD_TITLE: 'Effort Upload',
  CUSTOM_DATE_PLACEHOLDER: 'Custom Effort Date Range',
  RUN_EFFORT_UPLOAD: 'Run Effort Upload',
  OOPS_TRY_AGAIN: 'Oops! Please try again',
  EFFORT_UPLOAD_ADD_SUCCESS: 'Manually triggered Successfully',
  UNABLE_TO_ADD_EFFORT_UPLOAD: 'Unable to upload effort! please try again',
  ADD_BUTTON_TEXT: 'Run Effort Upload',
  SELECT_START_DATE: 'Select Effort Start Date*',
  SELECT_END_DATE: 'Select Effort End Date*',
  PLACEHOLDER: 'Choose Date',
  RUN_BUTTON: 'Run Effort Upload',
};

export const SESSION_TIMEOUT_POP = {
  MESSAGE_TEXT: 'You have been logged out due to inactivity',
  BUTTON_TEXT: 'Login',
  BUTTON_ID: 'session-out',
  SESSION_TIMEOUT: 'Session timeout!',
};
export const MIS_COLLECTION_REPORT_TITLE = 'Collection report';
export const MIS_COLLECTION_REPORT = {
  DSO: 'Days Sales Outstanding (DSO)',
  TOTAL_RECEIVABLE: 'Total Receivable',
  COLLECTION_PROJECTION: 'Collection Projection',
  BREAKUP_COLLECTION_PENDING: 'Breakup of Collection Pending',
  AGING_ACCOUNTS_RECEIVABLE: 'Aging of Accounts Receivable',
  COLLECTION_EFFECTIVENESS_INDEX: 'Collection Effectiveness Index (CEI)',
  BAD_DEBT_RATIO: 'Bad Debt Ratio',
};
export const STAFF_AUG_REPORT = {
  REPORT_TITLE: 'Staff augmentation reports',
  OPP_OVERVIEW: 'Opportunities Overview',
  LOST_DROPPED: 'Lost / Dropped Report',
  PENDING_POSITIONS: 'Pending Positions',
  CLOUSRES_THIS_WEEK: 'Closures this week',
  DELVRY_MNGR_WSE_DATA: 'Delivery manager wise data',
  SALSE_MEMBRS_WSE_DATA: 'Sales member wise data',
  RSOURSE_PNDG_ONBRDNG: 'Resources pending onboarding',
};

export const STAFF_AUG_STATUS_MASTER = {
  REQUIREMENT_STATUS_TITLE: 'Staff Aug status - Requirement status',
  CLIENT_STATUS_TITLE: 'Staff Aug status - Client interview status',
  LOST_DROPPED: 'Staff Aug status - Lost/Dropped status',
  GEOGRAPHY: 'Staff Aug status - Geography',
  STAFF_STATUS_MASTER_FIELD: {
    STATUS_NAME: 'statusName',
    REASON: 'reason',
    DESCRIPTION: 'statusDescription',
    COLOR: 'statusColor',
    IS_ACTIVE: 'isActive',
  },
  STAFF_STATUS_MASTER_HEADERNAME: {
    STATUS_NAME: 'Status name',
    REASON: 'Reason',
    DESCRIPTION: 'Description',
    COLOR: 'Color',
    IS_ACTIVE: 'Actions',
  },
  NEW_STATUS: 'Create new status',
  ADD_GEOGRAPHY: 'Add Geography',
  DELETE: {
    BUTTON_TEXT: 'Delete',
  },
  DELETE_SUCCESS: 'Status has been deleted',
  DELETE_STAFF_AUG_STATUS: 'Status has been deleted',
  DELETE_STAFF_AUG_STATUS_TITLE_TEXT: 'Delete status',
  DELETE_STAFF_AUG_DEAL_TYPE_TITLE: 'Delete Geography',
  DELETE_STAFF_AUG_STATUS_MESSAGE:
    'Are you sure you want to delete this status?',
  DELETE_STAFF_AUG_DEAL_TYPE_MESSAGE:
    'Are you sure you want to delete this geography?',
  DELETE_STAFF_AUG_STATUS_ID: 'Delete status',
  DELETE_STAFF_AUG_STATUS_BUTTON: 'Delete',
  DELETE_STAFF_AUG_STATUS_BUTTON_ID: 'delete-staff-aug-status',
  OOPS_TRY_AGAIN: 'Oops! Please try again',
  REQUIREMENT_STATUS_IN_USE:
    // eslint-disable-next-line max-len
    "The status is already in use. Please un-map the status under 'staff augmentation requirement' section to proceed with {operation}.",
  CLIENT_STATUS_IN_USE:
    // eslint-disable-next-line max-len
    "The status is already in use. Please un-map the status under 'staff augmentation resourcing' section to proceed with {operation}.",
};
export const ADD_EDIT_STAFF_AUG_STATUS = {
  ADD_STATUS: 'Create new status',
  EDIT_STATUS: 'Edit status',
  STATUS_NAME: 'Status name*',
  STATUS_NAME_PLACEHOLDER: 'Enter status name',
  DESCRIPTION: 'Description*',
  DESCRIPTION_PLACEHOLDER: 'Enter description',
  COLOR: 'Color*',
  COLOR_PLACEHOLDER: '#fffff',
  ADD_SUCCESS_MSG: 'Status has been created',
  EDIT_SUCCESS_MSG: 'Status has been updated',
  DESCRIPTION_MUST_BE: 'Description must be 2 to 250 characters long',
  STATUS_NAME_REQUIRED_FIELD: 'Status name is required',
  DESCRIPTION_REQUIRED_FIELD: 'Description is required',
  COLOR_REQUIRED_FIELD: 'Color is required',
  STATUS_NAME_MUST_BE: 'Status name must be between 2 and 20 characters long',
  STATUS_NAME_INVALID: 'Status name can only contain letters and spaces',
  COLOR_ALREADY_EXISTS: 'Color already exists',
  STATUS_NAME_ALREADY_EXISTS: 'Status name already exists',
  STATUS_NAME_SELECT_PLACEHOLDER: 'Select',
  REASON: 'Reason*',
  REASON_PLACEHOLDER: 'Enter the reason',
  REASON_REQUIRED_FIELD: 'Reason is required',
  REASON_ALREADY_EXISTS: 'Status name with same reason already exists',
  REASON_MUST_BE: 'Reason must be 2 to 250 characters long',
  LOST_DROPPED_STATUS_DESCRIPTION: 'Description',
};

export const DEAL_MANUAL_ASSIGNMENT = {
  ASSIGN_PROJECT_FOR_REVIEW: 'Assign Project for Review',
  ASSIGN_PROJECT_FOR_PERSON: 'Assign project to the Person for reviewing ',
};

export const ASSIGN_TEXT = 'Assign';
export const DATA_CONFIGURATION = {
  TITLES_TEXT: 'Date configuration',
  EFFORT_UPLOAD: 'Effort upload',
  LEAVE_UPLOAD: 'Leave upload',
  SELECT_TIMESTAMP: 'Select timestamp',
  EFFORT_UPLOAD_ADD_SUCCESS:
    'Date configuration for effort upload is successful',
  LEAVE_UPLOAD_ADD_SUCCESS: 'Date configuration for leave upload is successful',
  FROM: 'From*',
  TO: 'To*',
  SET: 'Set',
  CHECKBOX_CONTENT: 'Set same date interval for upcoming months',
};

export const ENABLE_DISABLE_DIALOG = {
  ENABLE: {
    TITLE_TEXT: 'Enable',
    MESSAGE_TEXT: 'Are you sure you want to enable?',
    BUTTON_TEXT: 'Enable',
    BUTTON_ID: 'enable',
  },
  DISABLE: {
    TITLE_TEXT: 'Disable',
    MESSAGE_TEXT: 'Are you sure you want to disable?',
    BUTTON_TEXT: 'Disable',
    BUTTON_ID: 'disable',
  },
};

export const STAFF_AUGMENTATION = {
  TITLE_TEXT: 'Staff - Augmentation',
  ADD_REQUIREMENT: 'Add requirement',
  DOWNLOAD_FAILURE_MESSAGE: 'Failed to download excel file',
  DATE_ERROR_MESSAGE: 'Please enter a valid date',
  CLOSURE_DATE_ERROR_MESSAGE: 'Closure date must be greater than raised date',
  FILE_TYPE_ERROR: 'Only pdf or doc file is accepted',
  DOWNLOAD: 'Download',
  RESUME: 'Resume',
  GENERATE_RESUME: 'Generate Resume',
  RESUME_UPLOAD_TITLE: 'Resume upload',
  RESUME_WATERMARK_TITLE: 'Resume Watermark',
  CONTINUE: 'Continue',
  GENERATE_RESUME_WATERMARK_TEXT: 'Generate resume with watermark',
  CONVERT_RESUME_WATERMARK_TEXT: 'Convert resume with watermark',
  UPLOAD: 'Upload',
  VIEW_SUGGESTIONS: 'View suggested',
  SUGGESTED: 'Suggested',
  ADD: 'Add',
  REQUEST_RESOURCING: {
    MAP_EMPLOYEE: 'Map employee',
    EDIT_MAP_EMPLOYEE: 'Edit map employee',
    HEADER: ' - Request resourcing',
    UPDATE_SUCCESS_MESSAGE: 'Status has been updated',
    UPDATE_ERROR_MESSAGE: 'Failed to update status',
    DELETE_RESOURCE_TITLE_TEXT: 'Delete mapping',
    DELETE_RESOURCE_MESSAGE: 'Are you sure you want to delete this mapping?',
    RESUME_GENERATED: 'Generated resume successfully',
    RESUME_GENERATION_INITIATED: 'Resume generation is in-progress. Please check the Resume Status column for updates.',
    RESUME_UPDATED: 'Resume updated successfully',
    RESUME_UPDATE_FAILED: 'Failed to update resume',
    RESUME_CONVERSION_SUCCESS: 'Resume converted successfully',
    RESUME_CONVERSION_FAILED: 'Failed to convert resume',

    FIELDS: {
      DATE: 'createdAt',
      EMPLOYEE_NAME: 'employeeName',
      EMPLOYEE_ID: 'employeeId',
      EMAIL_ID: 'emailId',
      SKILLS: 'skills',
      EXPERIENCE: 'experience',
      STATUS: 'status',
      INTERVIEW: 'isInteviewRequired',
      ACTIONS: 'actions',
      OTHERS: 'others',
      RESUME_STATUS: 'resumeGeneratedStatus',
    },
    HEADERS: {
      DATE: 'Date',
      NAME: 'Name',
      EMPLOYEE_ID: 'Employee ID',
      EMAIL_ID: 'Email ID',
      SKILLS: 'Skills',
      EXPERIENCE: 'Experience',
      STATUS: 'Status',
      INTERVIEW: 'Interview',
      ACTIONS: 'Actions',
      RESUME_GENERATION_STATUS: 'Resume Status',
    },
    ENABLE_DISABLE_DIALOG: {
      OOPS_TRY_AGAIN: 'Oops! Please try again',
      CANNOT_DISABLE:
        'You cannot disable a client interview that is mapped to users',
      ENABLE: {
        MESSAGE: 'Client interview is marked as not required',
        TITLE_TEXT: 'Enable interview',
        MESSAGE_TEXT: 'Are you sure you want to enable client interview?',
        BUTTON_TEXT: 'Enable',
        BUTTON_ID: 'enable-client-interview',
        RESPONSE_SUCCESS: 'client interview has been enabled',
      },
      DISABLE: {
        MESSAGE: 'Client interview is marked as required',
        TITLE_TEXT: 'Disable interview',
        MESSAGE_TEXT: 'Are you sure you want to disable client interview?',
        BUTTON_TEXT: 'Disable',
        BUTTON_ID: 'disable-client-interview',
        RESPONSE_SUCCESS: 'client interview has been disabled',
      },
    },
  },
  MAP_EMPLOYEE_FIELD: {
    EMPLOYEE_NAME: 'Employee Name*',
    EMPLOYEE_ID: 'Employee ID*',
    EMPLOYEE_EMAIL: 'Employee email*',
    STATUS: 'Status*',
    OTHERS: 'Others',
  },
  MAP_EMP_FIELD_PLACEHOLDER: {
    EMPLOYEE_NAME: 'Enter employee name',
    STATUS: 'Select',
  },
  EDIT_REQUIREMENT: 'Edit requirement',
  CLONE_REQUIREMENT: 'Clone requirement',
  STAFF_AUG_HEADERNAME: {
    OPPORTUNITY: 'Opportunities',
    VERTICAL: 'Vertical',
    LOCATION: 'Location',
    SKILLS: 'Skills',
    YEAR_OF_EXP: 'Years of experince',
    DURATION_MONTHS: 'Duration (Months)',
    RAISED_DATE: 'Raised date',
    JD_RECEIVED: 'JD received',
    DEAL_TYPE: 'Deal type',
    GEOGRAPHY: 'Geography',
    SALES_MANAGER: 'Sales member',
    DELIVERY_MANAGER: 'Delivery manager',
    NO_OF_POSITIONS: '# of positions',
    RESOURCE_ONBOARDED: 'Resources onboarded',
    INTERVIEW_REQUIRED: 'Interview required',
    CLOSED_POSITIONS: 'Closed positions',
    PENDING_POSITIONS: 'Pending positions',
    CLOSURE_DATE: 'Closure date',
    COMMENTS: 'Comments',
    LOST_DROPPED_TYPE: 'Lost / Dropped type',
    LOST_DROPPED_REASON: 'Lost / Dropped reason',
    STATUS: 'Current status',

    REQUIREMENT_ID: 'Requirement ID',
    REQUIREMENT_NAME: 'Requirement name',
    CREATED_DATE: 'Created date',
    ACTIONS: 'Actions',
  },
  STAFF_AUG_FIELD: {
    OPPORTUNITY: 'clientName',
    VERTICAL: 'verticalName',
    LOCATION: 'location',
    SKILLS: 'skillsName',
    YEAR_OF_EXP: 'experience',
    DURATION_MONTHS: 'duration',
    RAISED_DATE: 'requestedDate',
    JD_RECEIVED: 'isJdReceived',
    DEAL_TYPE: 'dealType',
    GEOGRAPHY: 'geographyPlace',
    SALES_MANAGER: 'salesMemberDetails',
    DELIVERY_MANAGER: 'deliveryManagerDetails',
    NO_OF_POSITIONS: 'positionCount',
    RESOURCE_ONBOARDED: 'isResourceOnboarded',
    INTERVIEW_REQUIRED: 'isInterviewRequired',
    CLOSED_POSITIONS: 'positionFilled',
    PENDING_POSITIONS: 'pendingPositions',
    CLOSURE_DATE: 'closureDate',
    COMMENTS: 'comment',
    LOST_DROPPED_TYPE: 'lostDropperdStatusName',
    LOST_DROPPED_REASON: 'lostDroppedReason',
    STATUS: 'statusName',

    REQUIREMENT_ID: 'requirementId',
    CLIENT_NAME: 'clientName',
    SKILL_NAME: 'skillsName',
    DATE: 'requirementDate',
  },
  STAFF_ADD_INPUTS: {
    OPPORTUNITIES_CLIENT_NAME: 'Opportunities / Client name',
    SALES_MEMBER: 'Sales member',
    DELIVERY_MANAGER: 'Delivery manager',
    VERTICAL: 'Vertical',
    SALES_MEMBER_ID: 'Sales member ID',
    DELIVERY_MANAGER_ID: 'Delivery manager ID',
    SKILLS: 'Skills',
    RESOURCE_ONBOARDED: 'Resource onboarded',
    OTHER_SKILLS: 'Skills ',
    IF_OTHER: '(if Other)',
    INTERVIEW_REQUIRED: 'Interview required',
    MAX_EXPERIENCE: 'Years of experience (Max)',
    MIN_EXPERIENCE: 'Years of experience (Min)',
    CLOSURE_DATE: 'Closure date',
    DURATION: 'Duration ',
    IN_MONTHS: '(in months)',
    COMMENTS: 'Comments',
    RAISED_DATE: 'Raised date',
    LOST_DROPPED_TYPE: 'Lost / Dropped type',
    REASON: 'Lost / Dropped reason',
    JD_RECEIVED: 'JD received',
    CURRENT_STATUS: 'Current status',
    UPLOAD_JD: 'Upload JD ',
    ONLY_FILE: '(Only pdf or doc file is accepted)',
    CHOOSE_FILE: 'Choose file',
    REQUIREMENT: 'Requirement*',
    DESCRIPTION: 'Description*',
    DATE: 'Requirement Creation Date*',
    MANDATORY_SKIll: 'Mandatory Skills*',
    LOCATION: 'Location',
    OPTIONAL_SKIll: 'Optional Skills*',
    STATUS: 'Status*',
    NO_OF_POSITIONS: 'Number of positions',
    DEAL_TYPE: 'Deal type',
    GEOGRAPHY: 'Geography',
    ROLES: 'Roles',
    ENTER_ROLES: 'Enter Roles',
    VISIBLE_TO_ALL_TEAM_MEMBERS: 'Visible to All Team Members',
  },
  GEOGRAPHY_REQUIRED: 'Please fill the required field',
  STAFF_ADD_INPUTS_PLACEHOLDER: {
    ENTER_OPPORTUNITY_NAME: 'Enter opportunity name',
    ENTER_SALE_MEMBER: 'Enter sales member name',
    ENTER_DELIVERY_MANAGER: 'Enter delivery manager name',
    ENTER_SKILLS: 'Enter skill',
    ENTER_ROLE: 'Enter Role name or Any Skills other than above',
    SELECT: 'Select',
    ENTER: 'Enter',
    ENTER_DURATION: 'Enter duration',
    ENTER_EXPERIENCE: 'Enter years of experience',
    ENTER_COMMENTS: 'Enter comments...',
    REQUIREMENT: 'Enter Requirement',
    DESCRIPTION: 'Enter Description',
    DATE: 'Choose date',
    MANDATORY_SKIll: 'Select Mandatory Skills',
    LOCATION: 'Enter location',
    OPTIONAL_SKIll: 'Select Optional Skills',
    STATUS: 'Select Status',
    NO_OF_POSITIONS: 'Enter number of positions',
    GEOGRAPHY: 'Select',
  },
  DESCRIPTION_LINES_ERROR_MESSAGE:
    'comments must be between 2 and 250 characters long',
  DESCRIPTION_LENGTH_ERROR_MESSAGE: 'comments must not exceed 250 characters',
  NO_OF_POSITIONS_IS_MANDATORY: 'Number of positions is mandatory',
  NO_OF_POSITIONS_ZERO_ERROR: 'Number of positions should be greater than 0',
  DURATION_ZERO_ERROR: 'Duration should be greater than 0',
  NO_OF_POSITIONS_CHAR_ERROR:
    'Invalid input: Only positive whole numbers are allowed.',
  DURATION_CHAR_ERROR: 'Duration should not be a decimal number',
  STAFF_ADD_SUCCESS_MESSAGE: 'Requirement added successfully',
  STAFF_ADD_FAIL_MESSAGE: 'Failed to add requirement',
  DELETE_STAFF_REQUIREMENT_TITLE_TEXT: 'Delete requirement',
  DELETE_STAFF_REQUIREMENT_MESSAGE:
    'Are you sure you want to delete this requirement?',
  DELETE_TECH_SESSION_BTN_ID: 'delete-tech-session-status',
  DELETE: {
    BUTTON_TEXT: 'Delete',
  },
  DELETE_SUCCESS_MESSAGE: 'Requirement has been deleted',
  DELETE_ERROR_MESSAGE: 'Oops! Something went wrong',
  RESOURCE_MAPPED:
    'The Resource is mapped for this requirement. Please un-map to proceed',
  DELETE_SUCCESS_SEVERITY: 'success',
  DELETE_ERROR_SEVERITY: 'error',
  FILL_REQUIRED_FIELD: 'Please fill the required field',
  LOST_DROPPED_REASON_REQUIRED: 'Please enter the Lost/ Dropped reason to proceed',
  UPDATE_SUCCESS_MESSAGE: 'Records has been updated',
  UPDATE_ERROR_MESSAGE: 'Failed to update requirement',
  DELETE_RESOURCE_SUCCESS_MESSAGE: 'Employee mapping has been deleted.',
  SUCCESS_SEVERITY: 'success',
  ERROR_SEVERITY: 'error',
  CHARACTER_LIMIT_EXCEEDED: 'Characters  limit exceeded',
  MAX_EXPERIENCE_SHOULD_BE_GREATER: 'Min experience cannot be greater than Max experience.',
  INVALID_EXPERIENCE: 'Experience should be a non-negative whole number.',
};

export const MIS_RESELLER_REPORT = {
  TITLE: 'Reseller projection report',
  LOADER_TEXT: 'Please select year and month to view the report.',
};

export const FILE_UPLOAD = {
  UPLOAD_FILE: 'Upload File',
  UPLOAD_SUCCESS: 'The file is uploaded successfully',
  UPLOAD_FAILURE: 'File upload failed',
  UPLOAD: 'Upload',
  FILE_UPLOAD: 'File Upload',
  UPLOAD_BY: 'uploadedBy',
  COLUMN_UPLOAD_BY: 'Uploaded By',
  UNABLE_TO_FILE_UPLOAD: 'Unable to upload file! please try again',
  POPUP_TITLE: 'File upload',
  DOWNLOAD_FAILURE: 'File download failed',
};

export const TECH_SESSION_PAGE = {
  MAP_EMPLOYEE: 'Create new session',
  CALENDER_HEADER: 'Tech Session - Calendar',
  USER_HEADER: 'Tech Session - Users',
  FIELDS: {
    CREATED_DATE: 'createdAt',
    SESSION_NAME: 'sessionName',
    DESCRIPTION: 'description',
    HOST_NAME: 'hostName',
    SESSION_TYPE: 'sessionType',
    SESSION_DATE: 'sessionDate',
    START_TIME: 'startTime',
    END_TIME: 'endTime',
    ACTIONS: 'actions',
  },
  HEADERS: {
    CREATED_DATE: 'Created date',
    SESSION_NAME: 'Session name',
    DESCRIPTION: 'Description',
    HOST_NAME: 'Host name',
    SESSION_TYPE: 'Session type',
    SESSION_DATE: 'Session date',
    START_TIME: 'Start time',
    END_TIME: 'End time',
    ACTIONS: 'Actions',
  },
  CARDS: {
    TOTAL_SESSIONS: 'Total session till date',
    UPCOMING_SESSIONS: 'Upcoming session',
    CURRENT_WEEK_SESSIONS: 'Session (This week)',
    TOTAL_HOSTS: 'Hosts',
  },
  DELETE_SUCCESS_MESSAGE: 'Requirement has been deleted',
  DELETE_ERROR_MESSAGE: 'Oops! Something went wrong',
  DELETE_SUCCESS_SEVERITY: 'success',
  DELETE_ERROR_SEVERITY: 'error',
  FILL_REQUIRED_FIELD: 'Please fill the required field',
  UPDATE_SUCCESS_MESSAGE: 'Records has been updated',
  UPDATE_ERROR_MESSAGE: 'Failed to update requirement',
  SUCCESS_SEVERITY: 'success',
  ERROR_SEVERITY: 'error',
  DELETE_TECH_SESSION_TITLE_TEXT: 'Delete session',
  DELETE_TECH_SESSION_MESSAGE: 'Are you sure you want to delete this session?',
  DELETE_TECH_MESSAGE: 'Tech session has been deleted',
  UPDATE_TECH_ERROR_MESSAGE: 'Failed to delete session',
  DELETE: {
    BUTTON_TEXT: 'Delete',
  },
  OOPS_TRY_AGAIN: 'Oops! Please try again',
};
export const PROJECT_OVERVIEW_PAGE = {
  TITLE: 'Project Overview',
};

export const MIS_HEALTH_CHECK = {
  TITLE: 'PMO health check',
  ARCHITECTURE_TITLE: 'Architecture Health Check',
};
export const HEALTH_CHECK_OVERVIEW = {
  TITLE: 'Health check overview',
};

export const TECH_SESSION = {
  ADD_SESSION: 'Add new session',
  ADD_EDIT_FIELDS: {
    SESSION_NAME: 'Session name*',
    ADD_HOST: 'Add host*',
    EMPLOYEE_ID: 'Employee ID*',
    EMPLOYEE_EMAIL: 'Employee email*',
    DESCRIPTION: 'Description',
    SESSION_TYPE: 'Session type*',
    SESSION_DATE: 'Session date*',
    ADD_GUESTS: 'Add guests*',
    SEND_INVITE: 'Send invite',
    START_TIME: 'Start time*',
    END_TIME: 'End time*',
    DL_LINK: 'DL link*',
  },
  ADD_EDIT_FIELDS_PLACEHOLDER: {
    SESSION_NAME: 'Enter session name',
    ADD_HOST: 'Search...',
    DESCRIPTION: 'Enter description...',
    SESSION_TYPE: 'Enter session type',
    SESSION_DATE: 'Choose date',
    START_TIME: 'Choose start time',
    END_TIME: 'Choose end time',
    DL_LINK: 'Add DL link',
  },
};

export const CERTIFICATION_MAP_SUCCESS_MESSAGE = {
  message: 'This list consists of all achieved and overachieved certification',
  severity: 'success',
};

export const DEAL_CLOUD_COST_FIELD = {
  SR_NO: 'srNo',
  ENVIRONMENT: 'resource',
  UNIT: 'unit',
  REQUIRED_UNIT: 'requiredUnits',
  REQUIRED_DURATION: 'requiredDuration',
  COST_AND_CURRENCY: 'perUnitCost',
  TOTAL_COST: 'cost',
};

export const DEAL_CLOUD_COST_HEADER = {
  SR_NO: 'Sr. No',
  ENVIRONMENT: 'Environment',
  UNIT: 'Unit',
  REQUIRED_UNIT: 'Required Units',
  REQUIRED_DURATION: 'Required Duration',
  COST_AND_CURRENCY: 'Cost',
  TOTAL_COST: 'Total Cost',
};

export const DELETE_CLOUD_COST = 'Data has been deleted';
export const CURRENCY_SYMBOL = '₹';

export const SCOPE_BE = {
  SUCCESS_MESSAGE: 'Your revised stories have been saved successfully.',
};

export const TRAINING_DETAILS = {
  OOPS_TRY_AGAIN: 'Oops! Please try again',
};

export const OPPORTUNITIES_OVERVIEW = {
  TITLE: 'Opportunities overview',
  VERTICAL: 'Vertical',
  DEAL_TYPE: 'Deal type',
  GEOGRAPHY: 'Geography',
  NO_OF_POSITIONS: 'No. of positions',
  CLOSED_POSITIONS: 'Closed positions',
  PENDING: 'Pending positions',
  LOST_POSITIONS: 'Lost positions',
  DROPPED_POSITIONS: 'Dropped positions',
  TOTAL: 'Total',
};

export const MAP_OPPORTUNITIES_OVERVIEW_FIELDS = {
  VERTICAL_NAME: 'verticalName',
  DEAL_TYPE: 'geographyType',
  GEOGRAPHY: 'geographyPlace',
  NO_OF_POSITIONS: 'totalPositions',
  CLOSED_POSITIONS: 'closedPositions',
  PENDING: 'pendingPositions',
  LOST_POSITIONS: 'lostPositions',
  DROPPED_POSITIONS: 'droppedPositions',
};

export const CLOUSER_REPORT = {
  DOWNLOAD_FAILURE_MESSAGE: 'Failed to download excel file',
  ERROR_SEVERITY: 'error',
  FIELDS: {
    CUSTOMER: 'clientName',
    DEAL_TYPE: 'geographyType',
    GEOGRAPHY: 'geographyPlace',
    VERTICAL: 'vertical',
    LOCATION: 'location',
    NO_OF_POSITIONS: 'pendingPositions',
    DETAILS: 'comment',
    SALES_TEAM_MEMBER: 'salesMember',
    DELIVERY_MANAGER: 'deliveryManager',
  },
  HEADER: {
    CUSTOMER: 'Customer',
    DEAL_TYPE: 'Deal type',
    GEOGRAPHY: 'Geography',
    VERTICAL: 'Vertical',
    LOCATION: 'Location',
    NO_OF_POSITIONS: 'No. of positions',
    DETAILS: 'Details',
    SALES_TEAM_MEMBER: 'Sales team member',
    DELIVERY_MANAGER: 'Delivery manager',
  },
};

export const LOST_DROPPED_REPORT = {
  DOWNLOAD_FAILURE_MESSAGE: 'Failed to download excel file',
  DOWNLOAD: 'Download',
  ERROR_SEVERITY: 'error',
  LOST_DROP_MASTER_FIELD: {
    REASON: 'reason',
    DEAL_TYPE: 'geographyType',
    GEOGRAPHY: 'geographyPlace',
    DROPPED: 'droppedPositions',
    LOST: 'lostPositions',
  },
  LOST_DROP_MASTER_HEADERNAME: {
    REASON: 'Lost / Dropped reason',
    DEAL_TYPE: 'Deal type',
    GEOGRAPHY: 'Geography',
    DROPPED: 'Dropped',
    LOST: 'Lost',
  },
};

export const PENDING_POSITIONS_REPORT = {
  DOWNLOAD: 'Download',
  DOWNLOAD_FAILURE_MESSAGE: 'Failed to download excel file',
  ERROR_SEVERITY: 'error',
  PENDING_POSITIONS_FIELDS: {
    VERTICAL: 'verticalName',
    DEAL_TYPE: 'geographyType',
    GEOGRAPHY: 'geographyPlace',
    PENDING_POSITIONS: 'pendingPositions',
    PENDING_JD: 'pendingJd',
    PENDING_CANDIDATE_IDENTIFICATIONS: 'pendingCandidateIndentification',
    PENDING_INTERVIEW: 'pendingInterviewFeedback',
  },
  PENDING_POSITIONS_HEADERS: {
    VERTICAL: 'Vertical',
    DEAL_TYPE: 'Deal type',
    GEOGRAPHY: 'Geography',
    PENDING_POSITIONS: 'Pending positions',
    PENDING_JD: 'Pending JD',
    PENDING_CANDIDATE_IDENTIFICATIONS: 'Pending candidate identification',
    PENDING_INTERVIEW: 'Pending interview / Interview feedback',
  },
  FETCH_ERROR: 'Failed to fetch data.',
  INVALID_DATE_RANGE: 'Please select valid date range.',
  NUMERIC_VALUE_ALLOWED: 'Only numeric values allowed',
  CAN_NOT_EMPTY: 'This field cannot be empty',

};

export const RECIEVE_REQUEST = {
  TECH_SESSION_RECIEVE_REQUEST: 'Tech session - Receive request',
  ERROR_SEVERITY: 'error',
  FIELDS: {
    HOST_NAME: 'hostName',
    TECH_SESSION_NAME: 'techSessionName',
    TOPIC: 'topic',
    CO_HOST: 'coHost',
    DATE: 'date',
    SLOT: 'slot',
    AUDIENCE_VERTICAl: 'audienceVertical',
    AUDIENCE_DEPARTMENT: 'audienceDepartment',
    TYPE: 'type',
    LOCATION: 'location',
    DESCRIPTION: 'description',
    STATUS: 'status',
    ACTIONS: 'actions',
  },
  HEADERS: {
    HOST_NAME: 'Host name',
    TECH_SESSION_NAME: 'Tech session name',
    TOPIC: 'Topic',
    CO_HOST: 'Co-Host',
    DATE: 'Date',
    SLOT: 'Slot',
    AUDIENCE_VERTICAl: 'Audience vertical',
    AUDIENCE_DEPARTMENT: 'Audience department',
    TYPE: 'Type',
    LOCATION: 'Location',
    DESCRIPTION: 'Description',
    STATUS: 'Status',
    ACTIONS: 'Actions',
  },
  API_ERROR_FOR_APPROVE: 'Failed to approve request',
  API_ERROR_FOR_REJECT: 'Failed to reject request',
  TECH_SESSION_REQUEST_APPROVED: 'Tech session request approved successfully',
  TECH_SESSION_REQUEST_REJECTED: 'Tech session request rejected successfully',
  SESSION_UPDATE_REQUEST_APPROVED: 'Tech session request approved successfully',
  SESSION_UPDATE_REQUEST_REJECTED: 'Tech session request rejected successfully',
};

export const UPDATE_RECEIVE_REQUEST = {
  TITLE: 'Update Session Request',
  SESSION_APPROVAL_REQUEST: 'Session is sent for approval',
  FIELDS: {
    HOST_NAME: 'Host name',
    SESSION_NAME: 'Name of tech session',
    ADD_HOST: 'Co-Host',
    TOPIC: 'Topic',
    SESSION_DATE: 'Date',
    START_TIME: 'Select slot',
    SELECT_AUDIENCE: 'Select audience',
    SESSION_TYPE: 'Session type',
    DESCRIPTION: 'Description',
    SEND_INVITE: 'Send email to invitees',
    LOCATION: 'Location',
  },
  PLACEHOLDER: {
    HOST_NAME: 'Enter name',
    SESSION_NAME: 'Enter name',
    ADD_HOST: 'Enter co-host name',
    DESCRIPTION: 'Write about tech session, this will be visible to all invitees...',
    TOPIC: 'Enter topic',
    SESSION_TYPE: 'Select',
    SESSION_DATE: 'Choose date',
    START_TIME: 'Choose start time',
    END_TIME: 'Choose end time',
    SELECT_VERTICAL: 'Select vertical',
    SELECT_DEPARTMENT: 'Select department',
  },
};
export const SALES_DELIVERY_WISE_REPORT = {
  DOWNLOAD_FAILURE_MESSAGE: 'Failed to download excel file',
  DOWNLOAD: 'Download',
  ERROR_SEVERITY: 'error',
  SALES_DELIVERY_FIELD: {
    SALES_MANAGER: 'salesMember',
    DELIVERY_MANAGER_FIELD: 'deliveryManager',
    DEAL_TYPE: 'geographyType',
    GEOGRAPHY: 'geographyPlace',
    NO_OF_POSITIONS: 'totalPositions',
    CLOSED_POSITIONS: 'closedPositions',
    PENDING_POSITIONS: 'pendingPosition',
    LOST_POSITIONS: 'lostPosition',
    CONVERSION_PERCENT: 'conversionRate',
    REVENUE_LOSS: 'revenueLoss',
  },
  SALES_DELIVERY_HEADERNAME: {
    SALES_MANAGER: 'Sales member',
    DELIVERY_MANAGER: 'Delivery manager',
    DEAL_TYPE: 'Deal type',
    GEOGRAPHY: 'Geography',
    NO_OF_POSITIONS: 'No. of positions',
    CLOSED_POSITIONS: 'Closed positions',
    PENDING_POSITIONS: 'Pending positions',
    LOST_POSITIONS: 'Lost positions',
    CONVERSION_PERCENT: 'Conversion %',
    REVENUE_LOSS: 'Revenue loss (Lac/PA)',
  },
};

export const SIGNUP_TECH_SESSION = {
  TITLE: 'Sign up to host a tech session',
  FIELDS: {
    HOST_NAME: 'Host Name*',
    SESSION_NAME: 'Name of tech session*',
    TOPIC: 'Topic*',
    ADD_HOST: 'Co-Host',
    SESSION_DATE: 'Date*',
    START_TIME: 'Select slot*',
    SELECT_AUDIENCE: 'Select audience*',
    SESSION_TYPE: 'Session type*',
    DESCRIPTION: 'Description',
    LOCATION: 'Location',
  },
  PLACEHOLDER: {
    HOST_NAME: 'Enter name',
    SESSION_NAME: 'Enter session name',
    TOPIC: 'Enter topic',
    ADD_HOST: 'Select',
    DESCRIPTION: 'Write about tech session, this will be visible to all invitees...',
    SESSION_TYPE: 'Select',
    SESSION_DATE: 'Choose date',
    START_TIME: 'hh:mm',
    END_TIME: 'hh:mm',
    SELECT_AUDIENCE: 'Select vertical',
    SELECT_DEPARTMENT: 'Select department',
    LOCATION: 'Select location',
  },
};
export const PENDING_ONBOARDING = {
  DOWNLOAD_FAILURE_MESSAGE: 'Failed to download excel file',
  ERROR_SEVERITY: 'error',
  FIELDS: {
    CUSTOMER: 'clientName',
    DEAL_TYPE: 'geographyType',
    GEOGRAPHY: 'geographyPlace',
    VERTICAL: 'vertical',
    LOCATION: 'location',
    NO_OF_POSITIONS: 'totalPositions',
    DETAILS: 'details',
    SALES_TEAM_MEMBER: 'salesMember',
    DELIVERY_MANAGER: 'deliveryManager',
  },
  HEADER: {
    CUSTOMER: 'Customer',
    DEAL_TYPE: 'Deal type',
    GEOGRAPHY: 'Geography',
    VERTICAL: 'Vertical',
    LOCATION: 'Location',
    NO_OF_POSITIONS: 'No. of positions',
    DETAILS: 'Details',
    SALES_TEAM_MEMBER: 'Sales team member',
    DELIVERY_MANAGER: 'Delivery manager',
  },
};

export const TECH_SESSION_SEND_EMAIL = {
  GENERIC_EMAIL: 'Generic email',
  CUSTOMIZED_EMAIL: 'Customized email',
  EMAIL_TITLE: 'Email*',
  EMAIL_PLACEHOLDER: 'Type your email here...',
  EMAIL_REQUIRED_FIELD: 'Email is required',
  SEND_EMAIL_SUCCESS: 'Email sent successfully',
  SEND_EMAIL_ERROR_SEVERITY: 'error',
  SEND_EMAIL_SUCCESS_SEVERITY: 'success',
  SEND_EMAIL_MESSAGE: 'Are you sure you want to send an email to the selected members?',
  SEND_EMAIL_BUTTON_TEXT: 'Send email',
  OOPS_TRY_AGAIN: 'Oops! Please try again',
  SEND_EMAIL_TITLE: 'Send email',
  VERTICAL_DEPARTMENT_REQUIRED: 'Vertical or Department is required',
  SESSION_NAME_REQUIRED: '[specific technology, tool, or topic area] is required',
  SESSION_DATE_REQUIRED: '[suggested date] is required',
  SESSION_START_TIME_REQUIRED: '[timeframe] is required',
  SESSION_END_TIME_REQUIRED: 'Session end time/duration is required',
  SESSION_TOPIC_REQUIRED: '[proposed topic/title] is required',
  SESSION_TYPE_REQUIRED: 'Session type is required',
  DATE_FORMAT_ERROR: 'Date should be in dd-mm-yyyy format',
  EMPLOYEE_NAME_NOTE: "Please don't change <Employee Name> Field.",
  HIGHLIGHTED_FIELDS_NOTE:
    'Make the necessary changes in the highlighted fields, and add valid date and time format as mentioned in the screen.',
};
export const TECH_SESSION_FIELDS = {
  USER_ID: 'USER_ID',
  ID: 'id',
  NAME: 'fullName',
  EMAIL: 'emailId',
  VERTICAL: 'vertical',
  CERTIFICATION_ID: 'certificationId',
  WORK_LOCATION: 'location',
  DEPARTMENT: 'department',
  DESIGNATION: 'designation',
  ALLOCATION: 'projectAllocation',
};
export const TECH_SESSION_HEADER = {
  ID: 'ID',
  NAME: 'Name',
  EMAIL: 'Email',
  VERTICAL: 'Vertical',
  CERTIFICATION_ID: 'Certification ID',
  WORK_LOCATION: 'Work location',
  DEPARTMENT: 'Department',
  DESIGNATION: 'Designation',
  ALLOCATION: 'Allocation',
};
export const DATE_NOTE_HEADING = 'Note:';
export const DATE_NOTE_DESCRIPTION = 'Please select date from start and end of the week (Monday to Sunday)';

export const DECLARE_SOURCE_REMARK = {
  TITLE: 'Declare source & remark',
  DECLARE_SOURCE: 'Source',
  DECLARE_REMARK: 'Remarks',
  SAVE: 'Save',
  UNABLE_TO_UPDATE: 'Unable to update source and remark! please try again',
  SUCESS_MESSAGE: 'Source and remark updated successfully',
};

export const ADD_PROJECT_TITLE = 'Add Projects';

export const DELETE_STAFFING_DIALOG = {
  TITLE_TEXT: 'Delete Staffing Request',
  BUTTON_TEXT: 'Delete',
  BUTTON_ID: 'Delete-mapping',
};

export const APPROVAL_STATUS_OPTIONS = [
  { label: 'Open', value: 0 },
  { label: 'Approved', value: 1 },
  { label: 'Rejected', value: 2 },
];

export const REQUEST_STATUS_OPTIONS = [
  { label: 'Open', value: 0 },
  { label: 'Closed', value: 1 },
];

export const DATE_TYPE_OPTIONS = [
  { label: 'Request Date', value: 'request_date' },
  { label: 'Approval Date', value: 'approval_date' },
  { label: 'Closed Date', value: 'closed_date' },
];

export const FILTER_ASSIGNED_TO_ME = '__assigned_to_me__';

export const STAFFING_REQUEST_EXPERIENCE_OPTIONS = [
  { label: 'Junior', value: 'Junior' },
  { label: 'Senior', value: 'Senior' },
];

export const STAFFING_DEFAULT_FILTERS = {
  verticals: [],
  projectIds: [],
  approvalStatus: [0],
  requestStatus: [0],
  resourceTypeIds: [],
  approvers: [],
  requestDateFrom: '',
  requestDateTo: '',
  approvalDateFrom: '',
  approvalDateTo: '',
  closedDateFrom: '',
  closedDateTo: '',
};

export const EMPTY_REQUEST_ROW = {
  projectId: '',
  vertical: '',
  experience: '',
  resourceNo: '',
  allocation: '',
  startDate: '',
  endDate: '',
  roleId: '',
  roleName: '',
  mandatorySkills: '',
  goodSkills: '',
  remarks: '',
};

export const MAX_CLIENT_RESULTS = 1000;
